import React, { useEffect, useState, useRef } from "react";
import { connect, useDispatch } from "react-redux";

import CustomModal from "../base/CustomModal";
import { enLocaleNumberFormatter, createAction } from "utils";
import UseCashQRCodeModal from "./UseCashQRCodeModal";
import { CashDollarBalanceSection } from "./UseCashDollar";
import { getMaxCashDollar, POINT_TO_CASH_CONVERT_RATE } from "./PointAndCashSection";
import i18n from '../../utils/I18n';
import './UsePointToCashModal.scss';

const UsePointToCashModal = ({
  currentPoints,
  frozenPoints,
  cashCodeKey,
  showModal,
  setShowModal,
}) => {
  const maxCashDollar = getMaxCashDollar(currentPoints);
  const [inputCashDollar, setInputCashDollar] = useState();
  const [showUseCashModal, setShowUseCashModal] = useState(false);
  const [cashDollarInputError, setCashDollarInputError] = useState();
  const dispatch = useDispatch();
  const payBtnRef = useRef();

  const isButtonDisabled = !inputCashDollar || inputCashDollar < 1;

  const fetchCashCode = ({ successAction, afterAction = () => { } }) => {
    if (inputCashDollar) {
      dispatch(createAction("users/createPointToCash")({
        cashDollarAmount: parseInt(inputCashDollar),
        successAction,
        afterAction
      }))
    }
  }
  const cancelPointToCash = () => {
    if (cashCodeKey) {
      dispatch(createAction("users/cancelPointToCash")())
    }
  }

  const refreshPointToCashCode = ({ failedAction }) => {
    dispatch(createAction("users/refreshPointToCash")({
      failedAction
    }))
  }

  const validateInput = () => {
    if (inputCashDollar > maxCashDollar) {
      setCashDollarInputError("exceed_point_balance")
      return false
    }
    return true;
  }

  const handlePayCashDollar = () => {
    if (!validateInput()) {
      return;
    }
    payBtnRef.current.disabled = true;
    fetchCashCode({
      successAction: () => {
        setShowModal(false);
        setShowUseCashModal(true);
      },
      afterAction: () => {
        payBtnRef.current.disabled = isButtonDisabled;
      }
    });
  }

  const refreshQRCodeAction = () => {
    refreshPointToCashCode({
      failedAction: () => {
        cancelPointToCash()
        setShowUseCashModal(false)
      }
    })
  }
  const getErrorMsg = () => {
    if (cashDollarInputError === "exceed_point_balance") {
      return i18n.t("exceed_point_balance", {
        points: enLocaleNumberFormatter(inputCashDollar * POINT_TO_CASH_CONVERT_RATE)
      })
    }
    return "";
  }

  useEffect(() => {
    return () => {
      dispatch(createAction("users/updateState")({
        cashCodeKey: ""
      }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const tabs = [
    {
      content: (
        <>
          <div className="cash-modal-descrition body-1">{i18n.t("use_cash_dollar_description")}</div>
          <div className="use-cash-dollar-modal-content">
            <CashDollarBalanceSection
              currentPoints={currentPoints}
              frozenPoints={frozenPoints}
            />
            <div>
              <div className="cash-modal-secondary-title subheading">{i18n.t("will_spend")}</div>
              <div>
                <div className="cash-dollar-input-area">
                  <input
                    className={inputCashDollar ? "title-x-large" : "field-text"}
                    type="number"
                    placeholder={i18n.t("records:please_input_hints")}
                    min={0}
                    max={9999999999}
                    value={inputCashDollar}
                    inputMode="numeric"
                    onChange={(e) => {
                      let maxLengthValue = e.target.value;
                      if (maxLengthValue && maxLengthValue.length > 10) {
                        maxLengthValue = maxLengthValue.substring(0, 10);
                      }
                      const inputData = maxLengthValue > 0 ? parseInt(maxLengthValue) : "";
                      setInputCashDollar(inputData)
                      if (cashDollarInputError) {
                        setCashDollarInputError()
                      }
                    }}
                  />
                  <div className="cash-point-balance-text body-2" style={{ textTransform: "lowercase" }}>{i18n.t("cash_dollar")}</div>
                </div>
                <div
                  className={
                    cashDollarInputError ?
                      "cash-modal-tips error-field tag-menu-1" : "cash-modal-tips tag-menu-1"
                  }
                >
                  {cashDollarInputError ? getErrorMsg()
                    : inputCashDollar ? i18n.t("points_will_be_used", {
                      points: enLocaleNumberFormatter(inputCashDollar * POINT_TO_CASH_CONVERT_RATE)
                    }) : null}
                </div>
              </div>
            </div>
            <div>
              <button
                ref={payBtnRef}
                className="custom-primary-button button-large"
                disabled={isButtonDisabled}
                onClick={handlePayCashDollar}
              >
                {i18n.t("pay_now")}
              </button>
              <div className="cash-modal-tips tag-menu-1">{i18n.t("confirm_pay_cash_tips")}</div>
            </div>
          </div >
        </>

      )
    }
  ]

  return (
    <>
      <CustomModal
        className="use-cash-dollar-modal"
        title={i18n.t("use_cash_dollar")}
        show={showModal}
        onClose={() => {
          setCashDollarInputError()
          setInputCashDollar()
          setShowModal(false)
        }}
        tabs={tabs}
        hideTab={true}
      />
      <UseCashQRCodeModal
        show={showUseCashModal}
        onHide={() => {
          setInputCashDollar()
          cancelPointToCash()
          setShowUseCashModal(false)
        }}
        cashDollar={inputCashDollar}
        code={cashCodeKey}
        refreshQRCodeAction={refreshQRCodeAction}
      />
    </>
  )

}

const mapStateToProps = state => {
  return {
    currentPoints: state.users.availablePoints,
    frozenPoints: state.users.frozenPoints,
    cashCodeKey: state.users.cashCodeKey,
  };
};

export default connect(mapStateToProps)(UsePointToCashModal);
